var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fruit_con"},[_c('canvas',{attrs:{"id":"fruitCanvas","height":_vm.fruitHeight,"width":_vm.fruitWidth}},[_vm._v("抱歉，您的浏览器不支持canvas元素")])])
}
var staticRenderFns = []

export { render, staticRenderFns }